import React from "react";
import { TextField, Autocomplete, MenuItem } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { FormGroup, Label } from "reactstrap";
function MultiSelect({options, keyField, formik, placeholder, label, onChange, handleInput, disabled,  multiple=true, required=true}) {

  const handleSelectChange = (event, newValue) => {
    if(Array.isArray(newValue)){
      formik.setFieldValue(keyField, newValue);
      if (onChange) onChange(newValue);
    }else{
      const selectedId = newValue?.value;
      formik.setFieldValue(keyField, selectedId);
      if (onChange) onChange(selectedId);
    }
  };

  const currentValue = multiple ? (formik?.values[keyField] || [])  : (options?.length > 0 ? options.find(option => option?.value === formik?.values[keyField]) : []) || null;

  return (
    <div className='input-field'>
      <FormGroup>
      <Label>{label}</Label>
      {required ? <span style={{color : "red", marginLeft:"3px"}}>*</span> : null}
      <Autocomplete
        sx={{ m: 1, width: 500 }}
        multiple={multiple}
        options={options}
        getOptionLabel={(option) => option.label}
        onChange={handleSelectChange}
        onInputChange={handleInput}
        disabled={disabled}
        value={currentValue || null}
        // disableCloseOnSelect
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholder}
            disabled={disabled}
          />
        )}
        renderOption={(props, option, { selected }) => (
          <MenuItem
            {...props}
            key={option.value}
            value={option.value}
            sx={{ justifyContent: "space-between" }}
            // disabled={currentValue && currentValue?.some((item) => item.value === option.value)} // Disable already selected options
          >
            {option.label}
            {selected ? <CheckIcon color="info" /> : null}
          </MenuItem>
        )}
      />
      <div>
        {formik?.touched[keyField] && formik?.errors[keyField] ? <span style={{color : "red"}}>{formik?.errors[keyField]}</span> : ""}
      </div>
   </FormGroup>
  </div>
  );
}

export default MultiSelect;
